
import {IonButtons, IonHeader, IonToolbar, IonContent, IonPage, IonTitle, IonBackButton} from '@ionic/vue';
import {defineComponent, inject} from "vue";
import { useStore } from 'vuex'
import {useRouter} from "vue-router";
import User from "@/types/User";

export default defineComponent({
  name: "Profile",
  components: {
    IonBackButton,
    IonButtons,
    IonContent,
    IonHeader,
    IonPage,
    IonTitle,
    IonToolbar,
  },
  setup() {
    const Vue3GoogleOauth = inject('Vue3GoogleOauth')
    return {
      store: useStore(),
      router: useRouter(),
      Vue3GoogleOauth,
    }
  },
  computed: {
    user() {
      // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      // @ts-ignore
      return this.store.getters['auth/user']
    },
    token() {
      return localStorage.getItem('token')
    }
  },
  created () {
    // fetch the data when the view is created and the data is
    // already being observed
    this.getFullName()
  },
  methods: {
    getFullName(): void {
      if (this.user != null) {
        this.fullName = `${this.user.givenName} ${this.user.familyName}`
      } else {
        this.fullName = 'user is empty'
      }
    },
    async logout(): Promise<void> {
      // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      // @ts-ignore
      await this.$gAuth.signOut()
      await this.store.dispatch('auth/logout')
    },
    async getStore(): Promise<void> {
      console.debug("user getter: ", this.store.getters['auth/user'] as User)
      console.debug("events getter: ", this.store.getters['event/events'] as Event[])
    }
  },
  data() {
    return {
      fullName: "",
    };
  },
})
